import {  typeFlowerColors } from "../constants/constants";
import { getUtteranceLeafThreshold } from "../utils/treeUtils";

// Color name mapping for accessibility
const COLOR_NAMES = {
  yellowflower: 'yellow',
  blueflower: 'blue', 
  redflower: 'red',
  whiteflower: 'white'
};

/**
 * Generates alternative text for the talk tree visualization
 * @param {Object} treeData - Tree data containing statements and flowers
 * @param {string} speakerType - Type of speaker ('student' or 'tutor')
 * @returns {string} Accessible description of the tree
 */
export const generateTreeAltText = (treeData, speakerType = 'student') => {
  if (!treeData || !treeData.statements || treeData.statements.length === 0) {
    return `Empty talk tree for ${speakerType}. No talk moves detected.`;
  }

  const { statements, chronologicalFlowers = [] } = treeData;
  const leafThreshold = getUtteranceLeafThreshold(speakerType);
  const totalLeaves = Math.floor(statements.length / leafThreshold);
  
  // Count flowers by color
  const flowersByColor = { yellow: 0, blue: 0, red: 0, white: 0 };
  chronologicalFlowers.forEach(flower => {
    const color = typeFlowerColors[flower.type] || 'whiteflower';
    const colorName = COLOR_NAMES[color] || 'white';
    flowersByColor[colorName]++;
  });

  // Calculate branches (simplified version)
  const totalBranches = Math.max(totalLeaves, chronologicalFlowers.length);

  const parts = [`Talk tree with ${totalBranches} branches, ${totalLeaves} leaves`];
  
  Object.entries(flowersByColor).forEach(([color, count]) => {
    if (count > 0) {
      parts.push(`${count} ${color} flower${count !== 1 ? 's' : ''}`);
    }
  });

  return parts.join(', ') + '.';
};

/**
 * Generates alternative text for the flower color key
 * @returns {string} Accessible description of flower color meanings
 */
export const generateFlowerKeyAltText = () => {
  const colorMappings = [
    { color: 'yellow', talkMove: 'Making a Claim' },
    { color: 'blue', talkMove: 'Relating to Another Student' },
    { color: 'red', talkMove: 'Providing Evidence' }
  ];

  const descriptions = colorMappings.map(({ color, talkMove }) => 
    `${color} flowers represent ${talkMove}`
  );

  return `Flower color key: ${descriptions.join(', ')}.`;
};
